<template>
    <div class="offer-pdf-prev__text-item" v-if="offerTemplatePart.type_id != 5">
        <div class="offer-pdf-prev__del">
            <el-button type="danger" icon="el-icon-delete" @click="$emit('deleteElement', offerTemplatePart.id)"></el-button>
        </div>
        <h2 v-if="offerTemplatePart.headline" v-html="offerTemplatePart.headline"></h2>
        <div v-html="offerTemplatePart.template"></div>
    </div>
    <div class="offer-pdf-prev__text-item offer-pdf-prev__text-item--price" v-else>
        <div class="offer-pdf-prev__del">
            <el-button type="danger" icon="el-icon-delete" @click="$emit('deleteElement', offerTemplatePart.id)"></el-button>
        </div>
        <h2 v-if="offerTemplatePart.headline" v-html="offerTemplatePart.headline"></h2>
        <div v-html="offerTemplatePart.template_short"></div>
        <div class="row mt-3">
            <div class="col-4">Unsere Servicepakete</div>
            <div class="col-6">
                <div class="row">
                    <div class="col">Basic</div>
                    <div v-if="priceArr.priceCols == 2 || priceArr.priceCols == 3" class="col">Standard</div>
                    <div v-if="priceArr.priceCols == 3" class="col">Premium</div>
                </div>
            </div>
        </div>
        <div class="row" v-for="item in priceArr.texts">
            <div class="col-4">{{ item.name }}</div>
            <div class="col-6">
                <div class="row">
                    <div class="col">{{ item.price1 }}</div>
                    <div v-if="priceArr.priceCols == 2 || priceArr.priceCols == 3" class="col">{{ item.price2 }}</div>
                    <div v-if="priceArr.priceCols == 3" class="col">{{ item.price3 }}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">Preis in Prozent</div>
            <div class="col-6">
                <div class="row">
                    <div class="col">{{ priceArr.price1 }}%</div>
                    <div v-if="priceArr.priceCols == 2 || priceArr.priceCols == 3" class="col">{{ priceArr.price2 }}%</div>
                    <div v-if="priceArr.priceCols == 3" class="col">{{ priceArr.price3 }}%</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{

        props: {
            offerTemplatePart: Object
        },

        data() {
            return {
                priceArr: {
                    priceCols: null,
                    price1: null,
                    price2: null,
                    price3: null,
                    texts: []
                },
            }
        },
        created() {
            if (this.offerTemplatePart.type_id == 5){
                this.priceArr = this.offerTemplatePart.template;
            }
        }
    }
</script>
